// Набор в корпорацию (deus_nabor_v_korporatsiyu, cost 3) — oneshot.
// Призывает 3 deus_stazher (1/0/1, special) на 1-ю линию владельца.
// Если меньше 3 пустых слотов — заполняем доступные слева направо, остальные не призываются.

import { Card } from '../../card.js';
import { getFactionCards } from '../../../data/decks.js';
import { onUnitSummoned } from './hooks.js';
import { chargeInfluence } from './influence.js';

export const CARD_ID = 'deus_nabor_v_korporatsiyu';
export const STAZHER_ID = 'deus_stazher';
export const COST = 3;

export function canPlayNabor(state, playerIdx) {
  const p = state.players[playerIdx];
  if (p.influence < COST) return { ok: false, reason: 'not_enough_influence' };
  return { ok: true };
}

export function playNabor(state, playerIdx) {
  const can = canPlayNabor(state, playerIdx);
  if (!can.ok) return can;
  const p = state.players[playerIdx];
  if (!chargeInfluence(state, playerIdx, COST)) return { ok: false, reason: 'not_enough_influence' };
  const tpl = getFactionCards(p.hero.faction).find(c => c.id === STAZHER_ID);
  if (!tpl) {
    state.log.add(`Набор в корпорацию: шаблон Стажёра не найден`);
    return { ok: false, reason: 'no_template' };
  }
  // Заполняем 1-ю линию слева-направо.
  let placed = 0;
  for (let slot = 0; slot < 4 && placed < 3; slot++) {
    if (p.field[0][slot] !== null) continue;
    const stazher = new Card(tpl);
    stazher.ownerId = p.id;
    stazher.placedTurn = state.currentTurn;
    stazher.revealed = true;
    stazher.initiation = 0;          // Призыв игнорирует Режим ожидания.
    p.placeCard(stazher, 0, slot);
    placed++;
    onUnitSummoned(state, playerIdx, stazher);
  }
  state.log.add(`👥 ${p.name}: Набор в корпорацию — призвано Стажёров: ${placed}${placed < 3 ? ' (мест не хватило)' : ''}`);
  return { ok: true, placed };
}
